import React from "react"
import { Command } from "cmdk"

const SearchBarSkeleton = () => {
  return (
    <>
      <Command.Group className="max-h-[450px] animate-pulse p-6 xl:mx-6 xl:px-17 2xl:mx-12">
        <Command.Item
          key={""}
          value={""}
          className="mb-8 max-w-[6rem] bg-neutral-300"
        />
        <Command.Item key={""} value={""} className="mb-6 bg-neutral-300" />
        <Command.Item key={""} value={""} className="mb-6 bg-neutral-300" />
        <Command.Item key={""} value={""} className="mb-6 bg-neutral-300" />
        <Command.Item key={""} value={""} className="mb-6 bg-neutral-300" />
        <Command.Item key={""} value={""} className="mb-6 bg-neutral-300" />
      </Command.Group>
      <Command.Group className="all-results animate-pulse p-6 xl:px-17">
        <Command.Item
          className="max-w-[10rem] bg-neutral-300 pb-0 lg:mr-6 xl:mx-6  2xl:mx-12"
          value={"/search"}
          keywords={[]}
        >
          <div className="col-end-4 mb-2 h-[1rem] rounded-100 bg-neutral-300 " />
        </Command.Item>
      </Command.Group>
    </>
  )
}

export { SearchBarSkeleton }
